import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";

/** Affiche les erreurs OAuth éventuelles (?error=) après redirection. */
export default function AuthCallbackHandler() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const error = params.get("error");
    if (!error) return;

    const cleanSearch = new URLSearchParams(location.search);
    cleanSearch.delete("error");
    const rest = cleanSearch.toString();
    const target = rest ? `${location.pathname}?${rest}` : location.pathname;

    toast.error(decodeURIComponent(error));
    navigate(target, { replace: true });
  }, [location.pathname, location.search, navigate]);

  return null;
}
